<script>
const triggerErrorMargin = 1;

export default {
  props: {
    variants: {
      type: Array,
      required: true,
    },
    selectedVariant: {
      required: true,
    },
    variantLabel: {
      type: String,
      required: true,
    },
  },
  emits: ['newSelected'],
  methods: {
    checkIfSelectedVariant(variant) {
      /* returning empty string renders attribute without equal sign.
      returning undefined will omit the attribute,
      vue docs claim that returning false will work but it doesnt. */
      return this.selectedVariant === variant ? '' : undefined;
    },
    translateBooleanValues(variant) {
      if (variant !== 'true' && variant !== 'false') {
        return variant;
      }

      return variant === 'true'
        ? this.$globalTexts.global__yes || 'global__yes'
        : this.$globalTexts.global__no || 'global__no';
    },
  },
};
</script>

<template>
  <div class="product-variant__container">
    <div class="product-variant__label">
      {{ variantLabel }}
    </div>
    <div class="product-variant__list">
      <div
        class="product-variant__option product-variant"
        v-for="variant in variants"
        :key="variant.value"
        :checked="checkIfSelectedVariant(variant.value)"
        @click="$emit('newSelected', variant.value)"
      >
        {{ translateBooleanValues(variant.name) }}
      </div>
    </div>
  </div>
</template>

<style>
.product-variant__container {
  max-width: 100%;
  margin: 10px 0;
  position: relative;
  font-size: var(--size-xxs);
  line-height: var(--size-xs);
}

.product-variant__label {
  letter-spacing: 0.015em;
}

.product-variant__list {
  display: flex;
  flex-wrap: wrap;
}

.product-variant__list::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.product-variant__option {
  scroll-snap-align: center;
  margin-right: 8px;
  margin-top: 6px;
}

.product-variant__option[checked] {
  pointer-events: none;
  user-select: none;
  cursor: default;
}

.product-variant__trigger {
  height: 100%;
  width: 0px;
}

.trigger--right {
  width: 1px;
  flex-shrink: 0;
}

@media (--phone) {
  .product-variant__list {
    max-width: 100vw;
    margin: 0 -10px;
    padding: 0 10px;
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
  }

  .product-variant__option:last-child {
    margin-right: 0;
  }
}
</style>
